var gql = require("graphql-tag");

const MUTATE_SEARCH_EVENT_QUERY = gql`
    mutation(
        $query: String!
        $sessionId: String
        $streetId: Int
        $addressId: Int
    ) {
        sendAction(
            query: $query
            session_id: $sessionId
            action: {
                select_address: { street_id: $streetId, address_id: $addressId }
            }
        ) {
            id
        }
    }
`;

export default MUTATE_SEARCH_EVENT_QUERY;
